import styles from "./servicos-section.module.css";
import ServicoCard from "../../../components/HomeComponents/ServicoCard/servico-card";
import { useNavigate } from "react-router-dom";

interface IProps {
  onHandlePages: any;
}

const ServicosSection = ({ onHandlePages }: IProps) => {
  const navigate = useNavigate();

  const handleOnClickServicos = (newPage: string) => {
    onHandlePages(newPage);
    return navigate("/produtos");
  };

  return (
    <section className={styles.servicos_section}>
      <h2 className={styles.servicos_title}>NOSSOS PRODUTOS</h2>
      <span className={styles.line}></span>
      <ul className={styles.servicos}>
        <ServicoCard
          title="RWE Analytics"
          description="Realizamos consultorias em análises de dados de mundo real (RWD) de
          múltiplas fontes, produzindo resultados compilados em deck de slides e planilhas..."
          url="/produtos/rwe-analytics"
          onHandlePages={onHandlePages}
        />
        <ServicoCard
          title="Strategic Planning"
          description="A TruEvidence nasceu com o objetivo de dar suporte principalmente à
        indústria farmacêutica e instituições de saúde a criar e fazer uso das
        evidências científicas..."
          url="/produtos/strategic-planning"
          onHandlePages={onHandlePages}
        />
        <ServicoCard
          title="Trainings & Workshops"
          description="Ofertamos treinamentos e capacitações em temas relacionados à
          epidemiologia, desenhos de estudos, dados de mundo real (RWD) e evidência
          de mundo real (RWE)...."
          url="/produtos/trainings-workshops"
          onHandlePages={onHandlePages}
        />
      </ul>
      <button
        className={styles.btn_vejaMais}
        onClick={() => handleOnClickServicos("PRODUTOS")}
      >
        SAIBA MAIS
      </button>
    </section>
  );
};

export default ServicosSection;
